module.exports = __webpack_public_path__ + "img/39.e330c28e.png";